/**
 * Dashboard entity class
 */

/**
 * DashboardFactory
 * returns Dashboard entity class
 *
 * @class DashboardFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Dashboard} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DashboardFactory
 */
/* @ngInject */
export default function DashboardFactory ($http, Entity) {
  /* === Dashboard class === */

  /**
   * Dashboard model
   *
   * @class Dashboard
   * @classdesc Dashboard model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing Dashboard entity fields
   * @return {models.Dashboard} Dashboard entity
   */
  function Dashboard () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Dashboard.prototype = Object.create(Entity.prototype)
  Dashboard.prototype.constructor = Dashboard

  /* === Dashboard instance methods & fields === */

  Object.assign(Dashboard.prototype, {

    /**
     * Default structure
     *
     * @memberof models.Dashboard#
     * @type {Object}
     */
    structure () {
      return {
        totalSubscribersCount: this._updatable('count/subscribers'),
        activeSubscribersCount: this._updatable('count/subscribers'),
        expiredSubscribersCount: this._updatable('count/subscribers'),
        onHoldSubscribersCount: this._updatable('count/subscribers'),
        newSubscribersCount: this._updatable('count/subscribers/new'),
        newSubscribersGraph: this._updatable('graph/subscribers/new'),
        totalSubscribersGraph: this._updatable('count/subscribers/new'),
        activeSubscribersGraph: this._updatable('graph/subscribers'),
        mapInfo: this._updatable('map/devices'),

        // payments
        autopayPaymentsCount: this._updatable('widgets/agg/payments?autoPay=true'),
        allPaymentsCount: this._updatable('widgets/agg/payments'),
        paymentsCountBySystemType: this._updatable('widgets/agg/payments'),

        comparisonPaymentGraph: this._updatable('graph/agg/payments'),
        dynamicsPaymentGraph: this._updatable('graph/agg/payments'),
        dynamicsByPaymentTypesGraph: this._updatable('graph/agg/payments'),
        dynamicsByPaymentSystemTypesGraph: this._updatable('graph/agg/payments')
      }
    },

    /**
     * Initialize values for structure
     *
     * @param type
     * @param value
     * @returns {{update : (function(*) : *), value : *}}
     * @private
     */
    _updatable: (type, value = null) => {
      return {
        value,
        update: function (params) {
          return $http.get(`api/dashboard/widgets/${type}`, { params })
            .data()
            .then((result) => { this.value = result.payload })
        },
        // TODO: Hack!
        fakeUpdate: function (fakeData, time = 300) {
          const promise = new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fakeData)
            }, time)
          })

          return promise.then((result) => {
            this.value = result
          })
        }
      }
    }
  })

  /* === Dashboard static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Dashboard, Entity)
  Dashboard._name = 'Dashboard'
  Dashboard.init()

  return Dashboard
}
